import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { PosthogService } from './posthog.service';

// ErrorHandler padrão do Angular só loga no console e "engole" o erro antes
// dele virar um window.onerror — por isso o autocapture padrão do PostHog
// nunca veria erros de template/componente sem esse encaminhamento manual.
// Injector (não PosthogService direto) porque ErrorHandler é instanciado
// muito cedo no bootstrap, antes do DI normal estar pronto.
@Injectable()
export class PosthogErrorHandler implements ErrorHandler {

  constructor(private injector: Injector) {}

  handleError(error: unknown): void {
    console.error(error);

    try {
      this.injector.get(PosthogService).captureException(error);
    } catch (e) {
      console.error('[PosthogErrorHandler] falha ao encaminhar erro pro PostHog:', e);
    }
  }
}
